// extracted by mini-css-extract-plugin
export default {"information":"style_information__CkCMw","actions":"style_actions__K5CI5"};